@if (otpForm) {
  <div class="container">
    <form id="otp" [formGroup]="otpForm">
      <div class="input-wrapper">
        @for (item of otpForm.controls | keyvalue; track item; let i = $index) {
          <input
            #inputField
            placeholder="0"
            [attr.data-cy]="'otp-' + i"
            [id]="i"
            (paste)="handlePaste($event)"
            (keypress)="validateCharacter($event)"
            (keydown)="keyDownEvent($event)"
            (keyup)="changeFocus($event)"
            [maxLength]="1"
            [ngClass]="{invalid: otpForm.hasError('notMatch')}"
            class="input-container"
            [formControl]="getFormControlFromItem(item.key)" />
        }
      </div>
    </form>
    <div class="message" [ngClass]="{invalid: otpForm?.hasError('notMatch')}">
      {{ getMessage() }}
    </div>
  </div>
}
